import { Reveal, Eyebrow } from "./Reveal";
import { COMPS } from "../data/content";

export const Positioning = () => (
    <section id="positioning" data-testid="positioning-section" className="border-y border-white/10 bg-[#070c18]/70 py-24 sm:py-36">
        <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
            <Reveal className="mb-16 max-w-4xl">
                <Eyebrow>Positioning</Eyebrow>
                <h2 className="deck-heading font-display text-5xl sm:text-6xl tracking-[0.12em]">
                    BUILT ON <span>PROVEN DNA</span>
                </h2>
                <p className="mt-6 text-base sm:text-lg leading-relaxed text-zinc-400">
                    Every engine in Deadly Ambition has already been road-tested by a hit. What's new is the
                    combination — and the woman driving it.
                </p>
            </Reveal>

            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {COMPS.map((c, i) => (
                    <Reveal key={c.id} delay={i * 0.07}>
                        <article
                            data-testid={`comp-card-${c.id}`}
                            className="group h-full border border-white/10 bg-[#0b1220] p-8 transition-all duration-500 hover:border-[#d6c68e]/40 hover:bg-[#101a2e]"
                        >
                            <p className="font-mono text-[10px] tracking-[0.3em] text-[#d6c68e]">{c.source.toUpperCase()}</p>
                            <h3 className="mt-3 font-display text-3xl tracking-[0.04em] text-white">{c.title.toUpperCase()}</h3>
                            <p className="mt-4 text-sm leading-relaxed text-zinc-400">{c.why}</p>
                        </article>
                    </Reveal>
                ))}

                <Reveal delay={0.35}>
                    <article
                        data-testid="comp-card-liana-difference"
                        className="relative h-full overflow-hidden border border-[#d6c68e]/50 bg-gradient-to-br from-[#d6c68e]/15 via-[#0b1220] to-[#0b1220] p-8"
                    >
                        <p className="font-mono text-[10px] tracking-[0.3em] text-[#d6c68e]">THE POINT OF DIFFERENCE</p>
                        <h3 className="mt-3 font-display text-3xl tracking-[0.04em] text-white">LIANA CASTILLO</h3>
                        <p className="mt-4 text-sm leading-relaxed text-zinc-300">
                            A South American / Lebanese-Australian lead in the Nancy Drew / Veronica Mars lineage —
                            opening Latin American and Middle Eastern diaspora audiences the genre has never centred,
                            inside an Australian gothic world of sandstone and coastal noir.
                        </p>
                    </article>
                </Reveal>
            </div>
        </div>
    </section>
);
